import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import Carousel from 'nuka-carousel';

import styles from 'styles/components/common/imageCarousel.scss';

// Replacement for the standard nuka-carousel slide decorator which accounts for device width
const SlideCount = ({ currentSlide, goToSlide, slideCount, slidesToScroll },{ testId }) => {
  const indexes = [];
  for (let i = 0; i < slideCount; i += slidesToScroll) {
    indexes.push(i);
  }
  return (
    <ul className={styles.imageCarouselSlideCounter} style={{ minWidth: (slideCount * 35) }} data-test-id={testId('imageCarouselSlideCounter')}>
      {
        indexes.map(index => (
          <li key={index}>
            <button
              type="button"
              aria-hidden={true}
              tabIndex={-1}
              className={`${currentSlide === index ? styles.active : ''}`}
              onClick={goToSlide.bind(null, index)}/>
          </li>
        ))
      }
    </ul>
  );
};
SlideCount.propTypes = {
  currentSlide: PropTypes.number.isRequired,
  goToSlide: PropTypes.func.isRequired,
  slideCount: PropTypes.number.isRequired,
  slidesToScroll: PropTypes.number.isRequired
};

const ImageCarousel = createReactClass({
  mixins: [Carousel.ControllerMixin],
  getInitialState() {
    return {
      autoplay: this.props.autoplay,
      currentSlide: 0,
      isDragging: false
    };
  },

  componentDidUpdate() {
    const { currentSlide } = this.state;
    const { children, afterSlide } = this.props;
    const { carousel } = this.refs;

    if (children.length < currentSlide + 1) {
      carousel.goToSlide(0);
      afterSlide && afterSlide(0);
      this.setState({ currentSlide: 0 });
    }
  },

  onSlideChange(slideIndex) {
    const { afterSlide } = this.props;

    const { carousel } = this.refs;
    // Turn off autoplay on user interaction
    if (this.state.isDragging) {
      if (this.state.currentSlide !== slideIndex) {
        this.setState({ autoplay: false });
      }
      this.endTouch();
    }

    // Work around for https://github.com/kenwheeler/nuka-carousel/issues/129
    if (afterSlide && carousel.props.slideIndex !== slideIndex) {
      afterSlide(slideIndex);
    }

    // Set new current slide
    this.setState({ currentSlide: slideIndex });
  },
  // Work around bug where carousel does not always resize when images are loaded
  resizeCarousel() {
    this.refs.carousel?.setDimensions();
  },

  asyncResizeCarousel() {
    setTimeout(this.resizeCarousel);
  },

  startTouch() {
    this.setState({ isDragging: true });
  },
  endTouch() {
    this.setState({ isDragging: false });
  },

  render() {
    const { showSliderDecorator, slidesToScroll, slidesToShow, children, wrapAround, slideIndex } = this.props;
    const { testId } = this.context;
    const { autoplay } = this.state;
    let decorators = [];

    if (showSliderDecorator) {
      decorators = [{ component: SlideCount, style: { position: 'relative' } }];
    }

    return (
      <div
        onLoad={this.asyncResizeCarousel}
        data-test-id={testId('imageCarousel')}
        onTouchStart={this.startTouch}>
        <Carousel
          ref="carousel"
          data={this.setCarouselData.bind(this, 'carousel')}
          decorators={decorators}
          slidesToShow={slidesToShow}
          slidesToScroll={slidesToScroll}
          autoplay={autoplay}
          autoplayInterval={5000}
          wrapAround={wrapAround}
          afterSlide={this.onSlideChange}
          slideIndex={slideIndex}>
          {children}
        </Carousel>
      </div>
    );
  }
});

ImageCarousel.propTypes = {
  afterSlide: PropTypes.func,
  slidesToShow: PropTypes.number.isRequired,
  slidesToScroll: PropTypes.number.isRequired,
  autoplay: PropTypes.bool.isRequired,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  showSliderDecorator: PropTypes.bool,
  wrapAround: PropTypes.bool
};

ImageCarousel.defaultProps = {
  showSliderDecorator: true,
  wrapAround: true
};

ImageCarousel.contextTypes = {
  testId: PropTypes.func
};

SlideCount.contextTypes = {
  testId: PropTypes.func
};

export default ImageCarousel;
